// Libs
import { createTheme } from '@material-ui/core/styles';
import theme from '../../utils/theme';

// CustomTheme
const CustomTheme = createTheme(theme);

export default CustomTheme;
